import React from "react";
import { connect } from "react-redux";

import packageJSON from "../../../package.json";

interface props {}

const VersionNumber: React.FC<props> = () => {
  return (
    <span style={{ position: "absolute", bottom: "10px", left: "10px" }}>
      {packageJSON.version}
    </span>
  );
};

const mapStateToProps = (state: any) => ({
  loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(VersionNumber);
